import * as React from "react";
/** 20px line icons used by the order / booking detail modals (Client Order Tracking UI). */
const base = {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": true,
};
const stroke = {
    stroke: "currentColor",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
};
export const IconClose = () => (React.createElement("svg", { ...base },
    React.createElement("path", { d: "M15 5L5 15M5 5L15 15", ...stroke })));
export const IconArrowLeft = () => (React.createElement("svg", { ...base },
    React.createElement("path", { d: "M15.833 10H4.167M4.167 10L10 15.833M4.167 10L10 4.167", ...stroke })));
export const IconChevronDown = () => (React.createElement("svg", { ...base },
    React.createElement("path", { d: "M5 7.5L10 12.5L15 7.5", ...stroke })));
export const IconChevronRight = () => (React.createElement("svg", { ...base },
    React.createElement("path", { d: "M7.5 15L12.5 10L7.5 5", ...stroke })));
//# sourceMappingURL=modal-icons.js.map